import { render } from "./AssemblyProductive.vue?vue&type=template&id=da0d6c2c&scoped=true"
import script from "./AssemblyProductive.vue?vue&type=script&lang=js"
export * from "./AssemblyProductive.vue?vue&type=script&lang=js"

import "./AssemblyProductive.vue?vue&type=style&index=0&id=da0d6c2c&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da0d6c2c"]])

export default __exports__